import { FilterValues } from "components/filters/FilterContext";
import { DefaultPlannerSortFilter, getSortOption } from "components/filters/Filters/FilterTypes/PlannerSortFilterType";
import { mapAppointmentTypeFilterToInstruction, mapAppointPhaseFilterToInstruction, mapArtistFilterToInstruction, mapContactFilterToInstruction, mapProductionFilterToInstruction, mapResponseToAppointmentPhaseFilter, mapResponseToAppointmentTypeFilter, mapResponseToArtistFilter, mapResponseToContactFilter, mapResponseToProductionFilter, mapResponseToVenueFilter, mapResponseToWeekFilter, mapVenueFilterToInstruction, mapWeekFilterToInstruction } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
): server.dto.PlanningByWeekForInternalQuery => ({
  artistIds: mapArtistFilterToInstruction(filter.artist),
  contactIds: mapContactFilterToInstruction(filter.contact),
  productionIds: mapProductionFilterToInstruction(filter.production),
  venueIds: mapVenueFilterToInstruction(filter.venue),
  phases: mapAppointPhaseFilterToInstruction(filter.appointmentPhase),
  appointmentTypes: mapAppointmentTypeFilterToInstruction(filter.appointmentType),
  date: mapWeekFilterToInstruction(filter.week),
  order: filter.plannerSort.sortOption.value,
  cache: filterSet
});

export const mapResponseToFilterValues = (
  response: server.dto.PlanningByWeekForInternalFilters,
  _: FilterValues
): Partial<FilterValues> => ({
  artist: mapResponseToArtistFilter(response.artists),
  contact: mapResponseToContactFilter(response.contacts),
  production: mapResponseToProductionFilter(response.productions),
  venue: mapResponseToVenueFilter(response.venues),
  appointmentPhase: mapResponseToAppointmentPhaseFilter(response.phases),
  appointmentType: mapResponseToAppointmentTypeFilter(response.appointmentTypes),
  week: mapResponseToWeekFilter(response.date),
  plannerSort:{
    sortOption: response.order !== "unknown" ? getSortOption(response.order) : getSortOption(DefaultPlannerSortFilter)
  }
});
